import { Button, Form, Input, Space } from 'antd'
import { useForm } from 'antd/es/form/Form'
import { FC } from 'react'
import { useLoginMutation } from '../../../store/api/auth-api'
import LoginMutationArg from '../../../types/api/auth/requests/login-mutation-arg'
import Title from 'antd/es/typography/Title'
import styled from 'styled-components'
import { tokenStorage } from '../../../services/token-storage'
import useErrorModal from '../../../hooks/api/use-error-modal'

const Logo = styled.img`
    display: block;
    margin: 0 auto;
`

interface LoginFormProps {
    onSuccess: () => void
}

const LoginForm: FC<LoginFormProps> = ({ onSuccess }) => {
    const [form] = useForm<LoginMutationArg>()
    const [login, state] = useLoginMutation()
    const initialValues: LoginMutationArg = {
        identifier: '',
        password: '',
        // identifier: 'ryzhakov.r@mail.ru',
        // password: 'ryzhakov.r@mail.ru',
    }

    useErrorModal(state, 'Неверный логин или пароль')

    const onLogin = async () => {
        const result = await login(form.getFieldsValue())

        if (result.data) {
            tokenStorage.set(result.data.jwt)

            onSuccess()
        }
    }

    return (
        <Form form={form} initialValues={initialValues}>
            <Space direction={'vertical'}>
                <Logo src={'/logo-gamma.webp'} />
                <Title>Вход в систему</Title>
                <Form.Item
                    name={'identifier'}
                    rules={[{ required: true, message: 'Введите логин' }]}
                >
                    <Input placeholder='Введите логин' />
                </Form.Item>
                <Form.Item
                    name={'password'}
                    rules={[{ required: true, message: 'Введите пароль' }]}
                >
                    <Input.Password placeholder='Введите пароль' />
                </Form.Item>
                <Button type={'primary'} block onClick={onLogin}>
                    Войти
                </Button>
            </Space>
        </Form>
    )
}

export default LoginForm
